// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2Y-pW","ranges":"BmiRanges_ranges__2hVqk"};